
export type NotificationItemStatus = {
  isRead: boolean;
};
